/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type BuildingRole = (typeof BuildingRole)[keyof typeof BuildingRole];

export const BuildingRole = {
    BuildingViewOnly: 'BuildingViewOnly',
    BuildingAgent: 'BuildingAgent',
    BuildingOwner: 'BuildingOwner',
} as const;
